let vueScrolling;
function vueScrollState() {
    vueScrolling = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const scrollState = window.scrollState();

            Vue.onMounted(() => {
                scrollState.initiateScrollState();
            });

            return;
        },
    });
    vueScrolling.use(window.VueAppGlobals.pinia);
    vueScrolling.mount('#scrollState');
}
if (window.Vue && window.Pinia) {
    vueScrollState();
} else {
    window.addEventListener('vue-ready', function () {
        vueScrollState();
    });
}